import { render } from "./BookingPage.vue?vue&type=template&id=0a6a2ba0&ts=true"
import script from "./BookingPage.vue?vue&type=script&lang=ts"
export * from "./BookingPage.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/a-gallery-tvp/a-gallery-tvp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__